import { Toaster } from "shared/components/ui/toaster";
import "./App.css";
import {
  protectedRouteConfig,
  guestRouteConfig,
  publicRouteConfig,
} from "./shared/router/routeConfig";
import { RouteWrapper } from "./shared/router/RouteWrapper";
import { useEffect, useState } from "react";
import { appConfig } from "config/app-config";
import colorsStore from "shared/store/colorsStore";
import JwtAuthService from "shared/services/JwtAuthService";
import { ResponsiveProvider } from "shared/components/ResponsiveProvider";

function changeFavicon(src: string) {
  var link = document.createElement("link"),
    oldLink = document.getElementById("dynamic-favicon");
  link.id = "dynamic-favicon";
  link.rel = "shortcut icon";
  link.href = src;
  if (oldLink) {
    document.head.removeChild(oldLink);
  }
  document.head.appendChild(link);
}

function App() {
  const { setColorsConfigStore } = colorsStore();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    //** configure app */
    setColorsConfigStore();
    document.title = appConfig.title;
    changeFavicon(appConfig.favicon);

    // Initialize JWT authentication from URL and wait for it to complete
    const initAuth = async () => {
      try {
        await JwtAuthService.initializeFromUrl();
      } catch (error) {
        console.error("Failed to initialize JWT authentication:", error);
      } finally {
        setInitialized(true);
      }
    };

    window.addEventListener("message", (event) => {
      if (event.data?.type === "set-temp-title") {
        document.title = event.data.title;
      }
      if (event.data?.type === "restore-title") {
        document.title = appConfig.title;
      }
    });

    initAuth();
  }, []);

  if (!initialized) {
    return <div></div>;
  }

  return (
    <ResponsiveProvider>
      <Toaster />
      <RouteWrapper
        guestRouteConfig={guestRouteConfig}
        protectedRouteConfig={protectedRouteConfig}
        publicRouteConfig={publicRouteConfig}
      />
    </ResponsiveProvider>
  );
}

export default App;
